import { render, staticRenderFns } from "./ButtonBlockInListProduct.vue?vue&type=template&id=5435c701&scoped=true&"
import script from "./ButtonBlockInListProduct.vue?vue&type=script&lang=js&"
export * from "./ButtonBlockInListProduct.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=5435c701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435c701",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5435c701')) {
      api.createRecord('5435c701', component.options)
    } else {
      api.reload('5435c701', component.options)
    }
    module.hot.accept("./ButtonBlockInListProduct.vue?vue&type=template&id=5435c701&scoped=true&", function () {
      api.rerender('5435c701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ButtonBlockInListProduct.vue"
export default component.exports